export default "__VITE_ASSET__Cnt7yv0f__"